import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchDataActive, postData, fetchData1, fetchDataAccountsIncomeExpense, fetchData, postDataNew } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {
    Search as SearchIcon,

    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
//import { useNavigate } from 'react-router-dom';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TablePagination, TableBody, TableRow } from '@mui/material';



const EventCreate = (props) => {


    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState('');
    const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
    const [eventname, setEventName] = useState("");
    const [fromdate, setFromDate] = useState("");
    const [isEvent, setEvent] = useState(false);
    const [todate, setToDate] = useState("");
    const [description, setDescription] = useState("");
    const [venue, setVenue] = useState("");
    const [incomeestimate, setIncomeEstimate] = useState("");
    const [expenseestimate, setExpenseEstimate] = useState("");
    const [incomeactual, setIncomeActual] = useState("");
    const [expenseactual, setExpenseActual] = useState("");
    const [membertype, setMemberType] = useState(0);
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSave, setIsSave] = useState(false);
    const [memberlist, setMemberOptions] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [selectedMemberlist, setSelectedMemberList] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState({});
    const [selectedFamilyMembers, setSelectedFamilyMembers] = useState([]); // Store selected family members
    const [familyMembers, setFamilyMembers] = useState([]); // Store fetched family members
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [data, setData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [filterparticipantsData, setFilterParticipantsData] = useState([]);

    const [searchText, setSearchText] = useState('');
    const [searchMember, setSearchMember] = useState('');
    const [participantsData, setParticipantsData] = useState([/* Your participants data */]);
    const [isincome, setIncome] = useState(false);
    const [isExpense, setExpense] = useState(true);
    const [incomeexpenseDataList, setIncomeExpenseDataList] = useState([]);
    const [expenseDataList, setExpenseDataList] = useState([]);
    //const navigate = useNavigate();
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedRow, setEditedRow] = useState({ Description: '', Amount: '' });
    const [expenseEditingIndex, setExpenseEditingIndex] = useState(null);  // tracks which row is being edited
    const [tempData, setTempData] = useState({ Description: '', Amount: '' });
    const [selectedgroup, setselectedgroup] = useState("");
    const [eventIncomeExpenseselectedOption1, setEventIncomeExpenseSelectedOption] = useState(null);
    const [eventIncomeExpenseoptions, setEventIncomeExpenseOption1] = useState(null);
    const [parentGroupOptions, setParentGroupOptions] = useState([]);
    const [ispersonModalOpen, setPersonModalOpen] = useState(false);
    const [memberid, setMemberId] = useState("");
    const [natureOptions, setNatureOptions] = useState([]);
    const [parent, setParent] = useState();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user

            logout();
            return;
        }

    }, [isAuthenticated, clubId, token, logout]);


    const clearForm = () => {
        setEventName(""); setFromDate("");
        setToDate(""); setDescription("");
        setVenue(""); setIncomeEstimate("");
        setExpenseEstimate(""); setIncomeActual("");
        setExpenseActual("");

    };
    const [head, setAccountHead] = useState("");
    const [currency, setCurrency] = useState("INR");

    const [selectedpolarity, setSelectedPolarity] = useState(null); // Initialize to null
    const optionsp = [
        { value: 1, label: 'Dr' },
        { value: 2, label: 'Cr' },
    ];
    const [nature, setNature] = useState("1");
    const optionsn = [
        { value: 1, label: 'Income' },
        { value: 2, label: 'Expenditure' },
        { value: 3, label: 'Long Term Liabilities' },
        { value: 4, label: 'Current Liabilities' },
        { value: 5, label: 'Fixed Asset' },
        { value: 6, label: 'Current Asset' },
        { value: 7, label: 'Capital' },

    ];
    // const handleChange1 = (event) => {
    //     setNature(event); // Get selected value
    // };
    const handleChange1 = (selectedOption) => {
        setNature(selectedOption); // Get selected value
        if (selectedOption && selectedOption.value) { fetchParentGroups(selectedOption.value); }

    };

    const fetchParentGroups = async (natureId) => {
        try {
            const response = await fetchData('ParentGroupApi', `/${clubId}/${branchId}/${natureId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map((group) => ({
                    value: group.Id,
                    label: group.Head,
                }));

                //  setselectedgroup(options); // Clear previous selection (optional)
                if (options.length > 0) {
                    setParent(options[0].label);
                    setselectedgroup(options[0]);      
                }
            } else {
                console.warn('No parent groups found for selected nature.');
                setParentGroupOptions([]);
            }
        } catch (error) {
            console.error('Error fetching parent group data:', error);
            setParentGroupOptions([]);
        }
    };

     const fetchNatureData = async () => {
        fetchData('NatureApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {

                    const options = response.response_data.map(group => ({
                        value: group.Id,
                        label: group.Name
                    }));
                    setNatureOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Nature Details:', error);
            });
    };
    const handleParentGroupChange = (selectedOption) => {
        setselectedgroup(selectedOption); // Store the whole object


    };
    const [opening, setOpening] = useState(0);

    const handleChange2 = (event) => {
        setSelectedPolarity(event)
    };
    const [openingdate, setOpeningDate] = useState("");

    const handleFormSubmit1 = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData1(e);

    }


    const submitData1 = async (e) => {
        e.preventDefault();


        // Validation
        if (head === "" || opening === undefined || opening === null) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }
        const accountheads = {
            Head: head,
            Currency: currency,
            NatureId: nature.value,
            ParentGroupId: selectedgroup.value,
            ParentGroup: selectedgroup.label,
            Nature: nature.label,
            OpeningBalancePolarity: selectedpolarity.label,
            OpeningBalancePolarityId: selectedpolarity.value,
            OpeningBalanceDate: openingdate,
            OpeningBalanceAmt: opening,
            IsExpense: isExpense, // Set FromDate to null if One Time
            IsMeetingExpense: false,     // Set ToDate to null if One Time
            CreatedBy: userId || "",
            CreatedDate: new Date(),
            ClubId: clubId || "",
            BranchId: branchId || "",
            IsEvent: true,
            FeesId: 0,
            IsFees: false,

        };

        try {
            const response = await postData('AccountHeadApi', accountheads, token);
            console.log('Account Head Created successfully:', response);
            setSuccessMessage("Account Head Created successfully!");
            setErrorMessage("");

            // resetForm(); // Ensure this function resets all relevant state variables
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            window.location.reload();
        } catch (error) {
            console.error('Account Head Create error:', error);
            setErrorMessage("Error creating Account Head. Please try again.");
        }
        toggleModalCloseHead();

    };


    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }
    const handleSaveEdit = () => {
        const updatedList = [...incomeexpenseDataList];
        updatedList[editingIndex] = editedRow;
        setIncomeExpenseDataList(updatedList);
        setEditingIndex(null);
    };

    const handleCancelEdit = () => {
        setEditingIndex(null);
        setEditedRow({ Description: '', Amount: '' });
    };

    const submitData = async (e) => {
        e.preventDefault();



        if (!eventname && !fromdate && !todate && !venue) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }

        const EventMasterDatas = {
            Event: eventname,
            Description: description || "", // empty string instead of null
            Venue: venue || "",
            FromDate: fromdate || "",
            ToDate: todate || "",
            IncomeEstimate: incomeestimate || 0, // 0 instead of null for numbers
            ExpenseEstimate: expenseestimate || 0,
            IncomeActual: incomeactual || 0,
            ExpenseActual: expenseactual || 0,
            CreatedBy: userId || "",
            CreatedDate: new Date(),
            ClubId: clubId || "",
            BranchId: branchId || "",
            //EventId: eventId || null,
        };

        const Participants = participantsData.map(party => ({
            MemberName: party.MemberName,
            PhoneNumber: party.PhoneNumber,
            Remarks: party.Remarks,
            MemberId: party.MemberId,
            FamilyMemberId: party.FamilyMemberId,
            MemberType: party.MemberType,
            CreatedBy: userId || null,
            CreatedDate: new Date(),
        }));
        const IncomeAndExpense = incomeexpenseDataList.map(incomedata => ({
            Description: incomedata.Description,
            Amount: incomedata.Amount,
            IsIncome: incomedata.IsIncome,
            HeadId: incomedata.headId || null,
            CreatedBy: userId || null,
            CreatedDate: new Date(),
        }));


        const EventAndChild = {
            EventMasterData: EventMasterDatas,
            EventParticipantsData: Participants,
            EventIncomeAndExpenseData: IncomeAndExpense
        };

        try {

            const response = await postDataNew('EventApi', 'AddEvent', EventAndChild, token);
            // const response = await postData('EventApi', EventAndChild, token);
            console.log('Event Created success:', response);
            setSuccessMessage("Event Created successfully!");
            setErrorMessage("");
            clearForm();
            // navigate(`/EventEdit/${response.response_data}`); // Using navigate to programmatically redirect
            history.push(`/EventEdit/${response.response_data}`);
            setTimeout(() => {
                setSuccessMessage("");


            }, 3000);


        } catch (error) {
            console.error('Event Create error:', error);
        }
    };

    // const fetchParentData = async () => {
    //     fetchData('ParentGroupApi', `/${clubId}`, token)
    //         .then((response) => {

    //             if (response.responseCode === '1111') {

    //                 const options = response.response_data.map(group => ({
    //                     value: group.Id,
    //                     label: group.Name
    //                 }));
    //                 setParentGroupOptions(options);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Parent Group Details:', error);
    //         });
    // };
   

    const handleSearchChange = (e) => {
        const searchValue = e.target.value;
        setSearchText(searchValue);

        // Filtering based on the current input value (not the stale state value)
        let filteredParticipants = "";

        if (searchValue === "") {
            filteredParticipants = participantsData;  // No filter, use original data when search is empty
        } else {
            filteredParticipants = participantsData.filter(participant =>
                participant.memberName.toLowerCase().includes(searchValue.toLowerCase())
            );
        }
        setFilterParticipantsData(filteredParticipants);
    };
    const handleSearchmemberChange = (e) => {
        setSearchMember(e.target.value);
    };



    const fetchMember = async () => {
        try {
            // Construct params1 and params2
            const params1 = `/${clubId}`;
            const params2 = `?branchId=${branchId}`;

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
            // const response = await fetchData1('MemberApi', params1, params2, token);

            if (response.responseCode === '1111') {
                const options = response.response_data.map(member => ({
                    value: member.id,
                    //label: member.firstName,
                    label: `${member.firstName} ${member.lastName}`,  // Only format for the select dropdown
                    firstName: member.firstName,
                    lastname: member.lastName,
                    phoneNumber: member.phoneNumber,
                    email: member.email,
                }));
                setMemberOptions(options);
            }
        } catch (error) {
            console.error('Error fetching table data:', error);
        }
    };

    const fetchtableData1 = async () => {
        try {
            const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, true, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(incomeexpense => ({
                    value: incomeexpense.id,
                    label: incomeexpense.head,
                    isEvent: incomeexpense.isEvent
                }));
                const filteredOptions = options.filter(option => option.isEvent === true);
                setEventIncomeExpenseOption1(filteredOptions);
            }
            else {
                console.warn('Unexpected response code:', response.responseCode);
                // Handle other response codes if needed
            }
        } catch (error) {
            console.error('Error fetching AccountHead Details:', error);

            // Handle unauthorized error
            if (error.response && error.response.status === 401) {
                //logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                // Handle other errors, if any
                console.error('An unexpected error occurred.');
            }
        }
    };
    const fetchFamilyMembers = async (memberId) => {
        try {
            const response = await fetchData('MemberApi', `/GetMemberDetails/${memberId}`, token); // Use your API endpoint
            if (response.responseCode === '1111') {
                setFamilyMembers(response.response_data.familydata || []); // Update the family members state
            }
        } catch (error) {
            console.error('Error fetching family members:', error);
        }
    };
    const handleMemberSelectChange = (selectedOption) => {
        setSelectedMember(selectedOption.value);
        setPersonModalOpen(true);
        //fetchFamilyMembers(selectedOption.value);
    };

    const [isModalOpenNonMember, setIsModalOpenNonMember] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFamilyMemberModalOpen, setIsFamilyMemberModalOpen] = useState(false);
    const [isModalOpenIncome, setIsModalOpenIncome] = useState(false);
    const [isModalOpenCreateHead, setIsModalOpenCreateHead] = useState(false);
    const [isModalOpenExpense, setIsModalOpenExpense] = useState(false);
    const [newRecordData, setNewRecordData] = useState({
        MemberName: '',
        Remarks: '',
        PhoneNumber: '',
        MemberId: [],
        FamilyMemberId: '',
        MemberType: '',
    });
    const [incomeData, setIncomeData] = useState({
        Description: '',
        Amount: '',
        IsIncome: true
    });

    const [expenseData, setExpenseData] = useState({
        Description: '',
        Amount: '',
        IsIncome: false
    });


    // const [participantsData, setParticipantsData] = useState([]);
    const toggleModalNonMember = () => {
        setIsModalOpenNonMember(prev => !prev);

    };
    const toggleModalNonMemberClose = () => {
        setIsModalOpenNonMember(prev => !prev);
        setMemberType("");
        //setMemberType("");
    };

    const toggleModal = () => {
        setIsModalOpen(prev => !prev);
        //setMemberType("");
    };

    const toggleFamilyModal = () => {
        setIsFamilyMemberModalOpen(prev => !prev);
        //setMemberType("");
    };
    const toggleModalIncome = () => {
        setIsModalOpenIncome(prev => !prev);
        setEventIncomeExpenseSelectedOption(null);

    };
    const toggleModalNewHead = () => {
        setIsModalOpenCreateHead(prev => !prev);


    };
    const toggleModalCloseHead = () => {
        setIsModalOpenCreateHead(prev => !prev);

    };

    const toggleModalExpense = () => {
        setIsModalOpenExpense(prev => !prev);
    };

    const toggleModalClose = () => {
        setIsModalOpen(prev => !prev);
        setMemberType("");
        setSearchMember("");
    };

    const toggleFamilyModalClose = () => {
        setIsFamilyMemberModalOpen(prev => !prev);
        setMemberType("");
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setMemberType(value);

        // Open modals based on selection
        if (value === "1") {
            toggleModalNonMember();
        }
        else if (value === "2") {
            toggleModal(); // Open modal if Member is selected
        } else if (value === "3") {
            toggleFamilyModal(isFamilyMemberModalOpen); // Open family member modal
        } else {
            // Close both modals if Non-Member is selected
            setIsModalOpen(false);
            setIsFamilyMemberModalOpen(false);
        }
    };

    const handleIncomeInputChange = (event) => {
        const { name, value } = event.target;
        setIncomeData((prevData) => ({
            ...prevData,
            [name]: value, // Update the corresponding field in income data
        }));
    };
    const handleExpenseInputChange = (event) => {
        const { name, value } = event.target;
        setExpenseData((prevData) => ({
            ...prevData,
            [name]: value, // Update the corresponding field in expense data
        }));
    };
    // Filter participantsData based on search text in Remarks
    //const filteredParticipants = participantsData.filter(participant =>
    // participant.MemberName.toLowerCase().includes(searchText.toLowerCase())
    //);
    const filteredmembers = memberlist.filter(participant =>
        participant.label.toLowerCase().includes(searchMember.toLowerCase())

    );
    const addNonMemberRecord = () => {
        // Create a new participant object from the form input data
        const newParticipant = {
            MemberName: newRecordData.MemberName, // Name entered by user
            PhoneNumber: newRecordData.phoneNumber || '1234567890', // Fallback if phone number is not provided
            Remarks: 'N-M', // Non-Member since this is a non-member entry
            MemberId: 0, // Assuming 0 represents non-members
            FamilyMemberId: 0, // Not a family member in this case
            MemberType: 1 // Non-member type
        };

        // Check if the participant with the same MemberId or FamilyMemberId already exists
        const isDuplicate = newParticipant.FamilyMemberId !== 0 &&
            participantsData.some(
                participant => participant.FamilyMemberId === newParticipant.FamilyMemberId
                    && newParticipant.MemberType === 1
            );

        // Only add the new participant if it's not a duplicate
        if (!isDuplicate) {
            setParticipantsData((prevData) => [...prevData, newParticipant]);
            setFilterParticipantsData((prevData) => [...prevData, newParticipant]);
        }

        // Reset the form input fields
        setNewRecordData({ MemberName: '', phoneNumber: '' });

        // Close the modal
        toggleModalNonMember();
    };

    const addRecord = () => {
        // Add the selected members to participants data
        const newParticipants = selectedMemberlist.map((memberId) => {
            const selectedMember = memberlist.find((member) => member.value === memberId);
            return {
                MemberName: selectedMember.label,
                PhoneNumber: selectedMember.phoneNumber || '1234567890', // Fetch the actual phone number if available
                Remarks: memberId !== 0 ? 'C-M' : 'N-M',
                MemberId: selectedMember.value,
                FamilyMemberId: 0,
                MemberType: 2
            };
            setSearchMember("");
        });

        // Filter out any duplicates based on MemberId or FamilyMemberId
        const filteredNewParticipants = newParticipants.filter(newParticipant => {
            if (newParticipant.FamilyMemberId === 0) {
                // For new participants with FamilyMemberId = 0, only check duplicate based on MemberId
                return !participantsData.some(participant =>
                    participant.MemberId !== 0 && participant.MemberId === newParticipant.MemberId
                );
            } else {
                // Otherwise, check both MemberId (if not 0) and FamilyMemberId for duplicates
                return !participantsData.some(participant =>
                    (participant.MemberId !== 0 && participant.MemberId === newParticipant.MemberId) ||
                    participant.FamilyMemberId === newParticipant.FamilyMemberId
                );
            }
        });
        // Update participantsData with the new records (without duplicates)
        setParticipantsData((prevData) => [...prevData, ...filteredNewParticipants]);
        setFilterParticipantsData((prevData) => [...prevData, ...filteredNewParticipants]);
        // Reset the selection
        setSelectedMemberList([]);
        setSelectedMembers({});
        setMemberType("");

        // Close modal
        setIsModalOpen(false);
    };

    const addIncomeRecord = () => {
        const newIncome = {
            IsIncome: isincome,
            Description: isincome ? `${eventIncomeExpenseselectedOption1?.label} (Income)` : `${eventIncomeExpenseselectedOption1?.label} (Expense)`, // Add "(Income)" or "(Expense)" based on isincome
            Amount: parseFloat(incomeData.Amount), // Ensure the amount is a number
            headId: eventIncomeExpenseselectedOption1?.value || 0, // Use the selected option's value or 0 if not selected
        };

        // Update the income data list with the new record
        setIncomeExpenseDataList((prevData) => {
            const updatedData = [...prevData, newIncome];

            // Calculate the total income after adding the new record
            // const totalIncome = updatedData.reduce((total, record) => total + record.Amount, 0);
            const totalIncome = updatedData
                .filter(record => record.IsIncome)
                .reduce((total, record) => total + record.Amount, 0);
            // Update the Income Estimate field
            setIncomeEstimate(totalIncome);

            const totalExpense = updatedData
                .filter(record => !record.IsIncome)
                .reduce((total, record) => total + record.Amount, 0);
            setExpenseEstimate(totalExpense);

            return updatedData;
        });

        // Reset the form input fields
        setIncomeData({
            Description: '',
            Amount: '',
            IsIncome: true,
            HeadId: '',
        });

        // Close the income modal
        toggleModalIncome();


        // Example to toggle between Income and Expense
        const toggleIncomeExpense = () => {
            setIncome(!isincome); // Toggle the income/expense state
            setExpense(!isExpense); // Optionally update the expense state too
        };

    }
    const handleCancel = () => {
        setEditingIndex(null); // Exit edit mode without saving
        setExpenseEditingIndex(null)

    };


    const handleInComeChange = (e) => {
        const { name, value } = e.target;
        setTempData({ ...tempData, [name]: value });
    };
    const handleEditClick = (index, income) => {
        setEditingIndex(index);
        setEditedRow({ ...income }); // clone current row data
    };
    // Handle checkbox state change
    const handleCheckboxChange = (event, memberId) => {
        if (event.target.checked) {
            // Add member to selected list
            setSelectedMemberList(prevState => [...prevState, memberId]);
            setSelectedMembers(prevState => ({
                ...prevState,
                [memberId]: 0 // Set default quantity (if needed)
            }));
        } else {
            // Remove member from selected list
            setSelectedMemberList(prevState => prevState.filter(id => id !== memberId));
            setSelectedMembers(prevState => {
                const newState = { ...prevState };
                delete newState[memberId]; // Remove quantity for deselected item
                return newState;
            });
        }
    };

    const handleCheckboxChangeFamily = (event, familymemeberId) => {
        if (event.target.checked) {
            // Add member to selected list
            setSelectedMemberList(prevState => [...prevState, familymemeberId]);
            setSelectedMembers(prevState => ({
                ...prevState,
                [familymemeberId]: 0 // Set default quantity (if needed)
            }));
        } else {
            // Remove member from selected list
            setSelectedMemberList(prevState => prevState.filter(id => id !== familymemeberId));
            setSelectedMembers(prevState => {
                const newState = { ...prevState };
                delete newState[familymemeberId]; // Remove quantity for deselected item
                return newState;
            });
        }
    };

    // Handle select/deselect all
    const handleSelectAllChange = (event) => {
        const isChecked = event.target.checked;
        setSelectAllChecked(isChecked);

        if (isChecked) {
            // Select all members
            const allMemberIds = memberlist.map((member) => member.value);
            setSelectedMemberList(allMemberIds);
            const allSelectedMembers = {};
            memberlist.forEach((member) => {
                allSelectedMembers[member.value] = 0; // Add default value or required state
            });
            setSelectedMembers(allSelectedMembers);
        } else {
            // Deselect all members
            setSelectedMemberList([]);
            setSelectedMembers({});
        }
    };

    // Handle select/deselect all
    const handleSelectAllChangeFamily = (event) => {
        const isChecked = event.target.checked;
        setSelectAllChecked(isChecked);

        if (isChecked) {
            // Select all members
            const allMemberIds = familyMembers.map((member) => member.id);
            setSelectedMemberList(allMemberIds);
            const allSelectedMembers = {};
            familyMembers.forEach((member) => {
                allSelectedMembers[member.id] = 0; // Add default value or required state
            });
            setSelectedMembers(allSelectedMembers);
        } else {
            // Deselect all members
            setSelectedMemberList([]);
            setSelectedMembers({});
        }
    };


    useEffect(() => {
        fetchMember();
        fetchtableData1();
        fetchNatureData();
        //fetchParentData();
    }, []);

    const addSelectedFamilyMembers = () => {
        // Check if any family members are selected
        if (selectedMemberlist.length === 0) {
            alert("Please select at least one family member."); // Provide feedback if no members are selected
            return;
        }

        const newParticipants = selectedMemberlist.map(memberId => {
            const familyMember = familyMembers.find(member => member.id === memberId);

            if (!familyMember) {
                console.error(`Family member with id ${memberId} not found.`);
                return null; // Return null for non-existent members
            }

            return {
                MemberName: familyMember.name,
                PhoneNumber: familyMember.phoneNumber || 'N/A',
                Remarks: 'F-M',
                MemberId: familyMember.memberId,
                FamilyMemberId: familyMember.id,
                MemberType: 3

            };
        }).filter(participant => participant !== null); // Filter out any null entries

        // Avoid adding duplicates
        const existingNames = new Set(participantsData.map(p => p.FamilyMemberId));
        const uniqueParticipants = newParticipants.filter(newParticipant => !existingNames.has(newParticipant.FamilyMemberId));

        // Update participants data
        setParticipantsData(prevData => [...prevData, ...uniqueParticipants]);
        setFilterParticipantsData(prevData => [...prevData, ...uniqueParticipants]);
        // Close the modal
        setIsFamilyMemberModalOpen(false);
        setMemberType("");

        // Provide success feedback (optional)
        if (uniqueParticipants.length > 0) {
            alert(`${uniqueParticipants.length} family member(s) added successfully.`);
        }
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const paginatedData = incomeexpenseDataList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const paginatedData1 = filterparticipantsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };


    const handleDelete = async (id, index) => {
        try {
            // Check if `id` is `0`, indicating a local deletion
            if (id === 0) {
                // Remove the item from the list by index
                setIncomeExpenseDataList((prevData) => prevData.filter((_, i) => i !== index));
                console.log('Record deleted locally');
                setSuccessMessage("Record deleted successfully!");
            } else {
                // Confirm deletion if needed
                if (!window.confirm("Are you sure you want to delete this item?")) {
                    return;
                }
            }

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Error deleting record:', error);
            setErrorMessage("Failed to delete the record. Please try again.");
        }
    };


    const [editingIndexn, setEditingIndexn] = useState(null);
    const [editedRown, setEditedRown] = useState({});

    // Switch the selected row to edit mode
    const handleEditClick1 = (index, childdata) => {
        setEditingIndexn(index);
        setEditedRown({ ...childdata });
        const handleSaveEdit = () => {
            const updatedData = [...participantsData];
            updatedData[editingIndex] = editedRow;
            setParticipantsData(updatedData);
            setEditingIndex(null);
            setEditedRow({});
        };

    };
    const handleSaveEdit1 = () => {
        const updatedData1 = [...participantsData];
        updatedData1[editingIndexn] = editedRown;
        setParticipantsData(updatedData1);
        setFilterParticipantsData(updatedData1);
        setEditingIndexn(null);
        setEditedRown();
    };

    // Cancel inline editing without saving changes
    const handleCancelEdit1 = () => {
        setEditingIndexn(null);
        setEditedRown();
    };


    const handleDelete1 = async (id, index) => {
        try {
            // Check if `id` is `0`, indicating a local deletion

            // Remove the item from the list by index
            setParticipantsData((prevData) => prevData.filter((_, i) => i !== index));
            setFilterParticipantsData((prevData) => prevData.filter((_, i) => i !== index));
            console.log('Record deleted locally');
            setSuccessMessage("Record deleted successfully!");


            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Error deleting record:', error);
            setErrorMessage("Failed to delete the record. Please try again.");
        }
    };

    const closeModal = () => {
        setPersonModalOpen(false);
    }

    const handleSearchChange1 = (e) => {
        setSearchTerm(e.target.value);
        setPersonModalOpen(true); // Open modal when typing in the search box
    };


    const handleRowClick = (member) => {
        const selectedOption = { value: member.value, label: member.label }
        //setSelectedMember(selectedOption);
        setSelectedMember(selectedOption.value);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setPersonModalOpen(false); // Close modal after selecting a member
        setMemberId(selectedOption.value);
        fetchFamilyMembers(selectedOption.value);

    };




    //-----------------------------Family details---------------

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
                <form onSubmit={handleFormSubmit}>
                    <div className="w-full flex justify-between items-center flex-wrap">
                        {/* Heading on the left */}
                        <h6 className='productHead linkcolor'
                            style={{ color: '#14528B', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                            EVENT CREATE
                        </h6>

                        {/* Buttons on the right */}
                        <div className="flex mt-2">
                            <Tooltip title="Save">
                                <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}>
                                    Save
                                </Button>
                            </Tooltip>
                            <Tooltip title="CANCEL">
                                <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#C62300', marginLeft: '5px', height: '25px' }}>
                                    <Link to="/EventIndex" className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        CANCEL
                                    </Link>
                                </Button>
                            </Tooltip>
                        </div>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full flex flex-wrap">
                        {/* <div className="w-full sm:w-3/5"> */}
                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label htmlFor="eventname">Event Name
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={eventname}
                                    onChange={(e) => setEventName(e.target.value)}
                                    type="text"
                                    placeholder="Enter Event Name"
                                />
                            </div>
                            <div className="w-1/10 mr-2">
                                <label htmlFor="fromdate">From
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={fromdate}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        if (todate && new Date(selectedDate) > new Date(todate)) {
                                            alert("From date cannot be greater than To date.");
                                            return;
                                        }
                                        setFromDate(selectedDate);
                                    }}
                                    type="date"
                                    placeholder="Select From Date"
                                />
                            </div>
                            <div className="w-1/10 mr-2">
                                <label htmlFor="todate">To
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={todate}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        if (fromdate && new Date(selectedDate) < new Date(fromdate)) {
                                            alert("To date cannot be earlier than From date.");
                                            return;
                                        }
                                        setToDate(selectedDate);
                                    }}
                                    type="date"
                                    placeholder="Select To Date"
                                />
                            </div>



                            <div className="w-1/2 mr-2">
                                <label htmlFor="description">Description</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    type="text"
                                    placeholder="Select description"
                                />
                            </div>

                        </div>
                        <div className="w-full mb-2 flex">
                            <div className="w-1/10 mr-2">
                                <label htmlFor="venue">Venue
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={venue}
                                    onChange={(e) => setVenue(e.target.value)}
                                    type="text"
                                    placeholder="Enter Venue"
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label htmlFor="incomeestimate">Income Estimate</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    //value={incomeestimate} // Bind this to the state
                                    value={Number(incomeestimate).toFixed(2)}
                                    onChange={(e) => setIncomeEstimate(e.target.value)} // Allow manual updates if necessary
                                    type="text"
                                    placeholder="Set Income Estimate"
                                />
                            </div>
                            <div className="w-1/10 mr-2">
                                <label htmlFor="expenseestimate">Expense Estimate</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={Number(expenseestimate).toFixed(2)}
                                    onChange={(e) => setExpenseEstimate(e.target.value)}
                                    type="text"
                                    placeholder="Expense Estimate"
                                />
                            </div>
                            <div className="w-1/8 mr-2">
                                <label htmlFor="incomeactual">Income Actual</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={Number(incomeactual).toFixed(2)}
                                    onChange={(e) => setIncomeActual(e.target.value)}
                                    type="text"
                                    placeholder="Income Actual"
                                />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label htmlFor="expenceactual">Expense Actual</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={Number(expenseactual).toFixed(2)}
                                    onChange={(e) => setExpenseActual(e.target.value)}
                                    type="text"
                                    placeholder="Expense Actual"
                                />
                            </div>
                        </div>


                        <div className="w-full flex flex-wrap">
                            {/* Income Details Table */}
                            <div className="w-full sm:w-2/5 pl-2">
                                <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}>

                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                                <TableRow>
                                                    <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px', fontSize: '14px', fontWeight: 'bold' }}><span style={{ color: 'green' }}>Income</span> <span style={{ marginLeft: '2.5px' }}></span>/<span style={{ color: 'brown', marginLeft: '2.5px' }}>Expense</span> Details
                                                        <IconButton onClick={toggleModalIncome} aria-label="add">
                                                            <AddIcon style={{ marginLeft: '5px' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Sl No</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Description</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Amount</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '5px' }}> </TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paginatedData.map((income, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell style={{ width: '10%', padding: '2px' }}>{index + 1}</TableCell>

                                                        {/* Description */}
                                                        <TableCell style={{ width: '17%', padding: '2px' }}>
                                                            {editingIndex === index ? (

                                                                <input
                                                                    name="description"
                                                                    value={editedRow.Description}
                                                                    onChange={(e) => setEditedRow({ ...editedRow, Description: e.target.value })}
                                                                />
                                                            ) : (
                                                                income.Description
                                                            )}
                                                        </TableCell>

                                                        {/* Amount */}
                                                        <TableCell style={{ width: '10%', padding: '2px' }}>
                                                            {editingIndex === index ? (


                                                                <input
                                                                    type="number"
                                                                    name="amount"
                                                                    value={editedRow.Amount}
                                                                    onChange={(e) => setEditedRow({ ...editedRow, Amount: e.target.value })}
                                                                />
                                                            ) : (
                                                                income.Amount
                                                            )}
                                                        </TableCell>

                                                        {/* Actions */}
                                                        <TableCell style={{ width: '10%', padding: '2px' }}>
                                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                                {editingIndex === index ? (
                                                                    <>
                                                                        <Tooltip title="Save">
                                                                            <IconButton onClick={handleSaveEdit} size="small">
                                                                                <CheckIcon style={{ color: 'green', fontSize: '20px', fontWeight: 'bold' }} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip title="Cancel">
                                                                            <IconButton onClick={handleCancelEdit} size="small">
                                                                                <CloseIcon style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Tooltip title="Edit">
                                                                            <IconButton onClick={() => handleEditClick(index, income)} size="small">
                                                                                <EditIcon style={{ color: 'teal' }} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip title="Delete">
                                                                            <IconButton onClick={() => handleDelete(income.id || 0, index)} size="small">
                                                                                <DeleteIcon style={{ color: 'red' }} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={incomeexpenseDataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            sx={{
                                                '& .MuiTablePagination-toolbar': {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap', // Ensures everything stays in one line
                                                    minHeight: '40px', // Keeps a proper height
                                                },
                                                '& .MuiTablePagination-selectLabel': {
                                                    marginBottom: 0, // Fixes label misalignment
                                                },
                                                '& .MuiTablePagination-displayedRows': {
                                                    marginBottom: 0, // Fixes row count misalignment
                                                },
                                            }}
                                        />
                                    </TableContainer>

                                </div>
                            </div>



                            {/* Event Participants Table */}
                            <div className="w-full sm:w-3/5 pl-2">
                                <div className="w-full mb-4 flex" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                                <TableRow>
                                                    <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '7px', fontSize: '16px', fontWeight: 'bold' }}>
                                                        <input
                                                            className="shadow text-gray-700 leading-tight"
                                                            type="text"
                                                            placeholder="Search..."
                                                            value={searchText}
                                                            onChange={handleSearchChange}
                                                            onFocus={() => setIsFocused(true)}
                                                            onBlur={() => setIsFocused(false)}
                                                            style={{
                                                                width: isFocused ? '200px' : '170px',
                                                                height: '30px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '15px',
                                                                padding: '0 20px',
                                                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                                                outline: 'none',
                                                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                                            }}
                                                        />
                                                        <span style={{ marginLeft: '5px' }}> Event Participants </span> <span style={{ color: 'brown' }}>Select Member :</span>
                                                        <select
                                                            name="membertype"
                                                            value={membertype}
                                                            onChange={handleInputChange}  // This will call handleInputChange only when a selection is made
                                                            className="ml-2 p-2 border rounded"
                                                        >
                                                            <option value="">Select an option</option>  {/* Default option */}
                                                            <option value="1">Non-Member</option>
                                                            <option value="2">Member</option>
                                                            <option value="3">Family-Member</option>
                                                        </select>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Name</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Phone No</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Remarks</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px' }}></TableCell>
                                                </TableRow>

                                            </TableHead>
                                            <TableBody>
                                                {paginatedData1.map((childdata, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>{childdata.MemberName}</TableCell>
                                                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>
                                                            {editingIndexn === index ? (
                                                                <input
                                                                    type="text"
                                                                    value={editedRown.PhoneNumber || ''}
                                                                    onChange={(e) =>
                                                                        setEditedRown({ ...editedRown, PhoneNumber: e.target.value })
                                                                    }
                                                                    style={{ padding: '5px', fontSize: 'inherit' }}
                                                                />
                                                            ) : (
                                                                childdata.PhoneNumber !== '0' ? childdata.PhoneNumber : 'N/A'
                                                            )}

                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>{childdata.Remarks}</TableCell>

                                                        <Box display="flex" alignItems="center" justifyContent="center">
                                                            {editingIndexn === index ? (
                                                                <>
                                                                    <Tooltip title="Save">
                                                                        <IconButton onClick={handleSaveEdit1} size="small">
                                                                            <CheckIcon style={{ color: 'green', fontSize: '20px' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Cancel">
                                                                        <IconButton onClick={handleCancelEdit1} size="small">
                                                                            <CloseIcon style={{ color: 'red', fontSize: '20px' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </>
                                                            ) : (
                                                                <>


                                                                    <Tooltip title="Edit">
                                                                        <IconButton onClick={() => handleEditClick1(index, childdata)} size="small">
                                                                            <EditIcon style={{ color: 'teal', fontSize: '20px' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Delete">
                                                                        <IconButton onClick={() => handleDelete1(childdata.id, index)} size="small">
                                                                            <DeleteIcon style={{ color: 'red', fontSize: '20px' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </>
                                                            )}
                                                        </Box>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={filterparticipantsData.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            sx={{
                                                '& .MuiTablePagination-toolbar': {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap', // Ensures everything stays in one line
                                                    minHeight: '40px', // Keeps a proper height
                                                },
                                                '& .MuiTablePagination-selectLabel': {
                                                    marginBottom: 0, // Fixes label misalignment
                                                },
                                                '& .MuiTablePagination-displayedRows': {
                                                    marginBottom: 0, // Fixes row count misalignment
                                                },
                                            }}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>

                        {isModalOpenIncome && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/10 mr-2">
                                            <label htmlFor="eventIncomeExpense">
                                                Select Event Head

                                            </label>
                                            <Select
                                                value={eventIncomeExpenseselectedOption1}
                                                onChange={(option) => setEventIncomeExpenseSelectedOption(option)}
                                                options={eventIncomeExpenseoptions}
                                                placeholder={'Select Event Expense Head'}
                                                isSearchable
                                                menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: "300px", // Default fixed width
                                                        minWidth: "200px", // Prevents shrinking smaller than this
                                                        maxWidth: "auto", // Expands if needed
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap"
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: "auto",
                                                        minWidth: "300px",
                                                        whiteSpace: "nowrap",
                                                        overflowX: "auto", // Allows horizontal scrolling if needed
                                                        overflowY: "hidden", // Disables vertical scrolling
                                                        maxHeight: "none"
                                                    }),

                                                }}
                                            />




                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                type="radio"
                                                id="isExpense"
                                                name="entityType"
                                                value="isExpense"
                                                checked={isExpense}
                                                onChange={() => {
                                                    setIncome(false);
                                                    setExpense(true);

                                                }}
                                            />
                                            <label htmlFor="isExpense" className="ml-2">Expense</label>

                                            <input
                                                type="radio"
                                                id="isincome"
                                                name="entityType"
                                                value="isincome"
                                                checked={isincome}
                                                onChange={() => {
                                                    setIncome(true);
                                                    setExpense(false);
                                                }}
                                                className="ml-4"
                                            />
                                            <label htmlFor="isincome" className="ml-2">Income</label>
                                        </div>
                                    </div>
                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/8 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GSTRate">
                                                Amount
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                type="text"
                                                name="Amount"
                                                placeholder="Enter Amount"
                                                value={incomeexpenseDataList.Amount}
                                                onChange={handleIncomeInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addIncomeRecord}>
                                            Add Record
                                        </button>
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalIncome}>
                                            Cancel
                                        </button>
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalNewHead}>
                                            + Head
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isModalOpenNonMember && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/10 mr-2">

                                            <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="MemberName"
                                                placeholder="Enter Name"
                                                value={newRecordData.MemberName}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/10 mr-2">
                                            <label className="tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GSTRate">
                                                Phone Number
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                type="text"
                                                name="phoneNumber"
                                                placeholder="Enter Phone Number"
                                                value={newRecordData.phoneNumber}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addNonMemberRecord}>
                                            Add Record
                                        </button>
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalNonMemberClose}>
                                            Cancel
                                        </button>

                                    </div>
                                </div>
                            </div>
                        )}


                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                                    <div className="w-full mb-4 flex items-center justify-between">
                                        {/* Select Members Label and Buttons */}
                                        <div>
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                                Search Member
                                            </label>
                                            <input

                                                type="text"
                                                placeholder="Search Member"
                                                value={searchMember}
                                                onChange={handleSearchmemberChange}
                                                className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            />

                                        </div>

                                        {/* Buttons placed next to the label */}
                                        <div className="flex">
                                            <button
                                                className="bg-green-500 text-white text-sm px-2 py-1 rounded-full mr-2"
                                                onClick={addRecord}
                                            >
                                                +
                                            </button>
                                            <button
                                                className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                                                onClick={toggleModalClose}
                                            >
                                                X
                                            </button>
                                        </div>
                                    </div>

                                    {/* <div className="overflow-hidden border border-gray-300 rounded">
                                        <table className="min-w-full border-collapse text-sm">
                                            <thead>
                                                <tr>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">
                                                        <span style={{ fontWeight: 'bolder' }}>Select
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAllChange}
                                                                checked={selectAllChecked}
                                                                style={{ marginLeft: '-55px' }}
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">Member</th>
                                                </tr>
                                            </thead>
                                        </table>

                                     
                                        <div className="overflow-y-auto max-h-48" style={{ height: '300px' }}>
                                            <table className="min-w-full border-collapse text-sm">
                                                <tbody>
                                                    {filteredmembers.map(member => (
                                                        <tr key={member.value}>
                                                            <td className="border px-2 py-1 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(event) => handleCheckboxChange(event, member.value)}
                                                                    checked={selectedMemberlist.includes(member.value)}
                                                                    style={{ height: '17px', textAlign: 'left' }}
                                                                />
                                                            </td>
                                                            <td className="border px-2 py-1 text-xs">
                                                                {member.label + "-" + member.phoneNumber + "-" + member.email}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div> */}

                                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        <table className="min-w-full border-collapse text-sm">
                                            <thead>
                                                <tr>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">
                                                        Select
                                                        <input
                                                            type="checkbox"
                                                            onChange={handleSelectAllChange}
                                                            checked={selectAllChecked}
                                                            style={{ marginLeft: '-20px' }}
                                                        />
                                                    </th>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">Name</th>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">Phone</th>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredmembers.map(member => (
                                                    <tr key={member.value}>
                                                        <td className="border px-2 py-1 text-center">
                                                            <input
                                                                type="checkbox"
                                                                onChange={(event) => handleCheckboxChange(event, member.value)}
                                                                checked={selectedMemberlist.includes(member.value)}
                                                                style={{ height: '17px', textAlign: 'left', marginLeft: '-10px' }}
                                                            />
                                                        </td>
                                                        <td className="border px-2 py-1 text-xs">
                                                            {member.label}
                                                        </td>
                                                        <td className="border px-2 py-1 text-xs">
                                                            {member.phoneNumber}
                                                        </td>
                                                        <td className="border px-2 py-1 text-xs">
                                                            {member.email}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                            </div>
                        )}

                        {isFamilyMemberModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                                    <div className="w-full mb-4 flex items-center justify-between">
                                        {/* Select Family Members Label and Buttons */}
                                        <div>
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                                Select Family Members
                                            </label>
                                        </div>

                                        {/* Buttons placed next to the label */}
                                        <div className="flex">
                                            <button
                                                className="bg-green-500 text-white text-sm px-2 py-1 rounded-full mr-2"
                                                onClick={addSelectedFamilyMembers}
                                            >
                                                +
                                            </button>
                                            <button
                                                className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                                                onClick={toggleFamilyModalClose}
                                            >
                                                X
                                            </button>
                                        </div>
                                    </div>

                                    {/* Family Member Select Dropdown */}
                                    <div className="mb-4">
                                        {/* <Select
                                            value={memberlist.find(member => member.value === selectedMember)} // Show selected value
                                            onChange={handleMemberSelectChange} // Handle selection
                                            options={memberlist} // Provide options (memberlist already has the right format)
                                            placeholder="Search and select member"
                                            isSearchable // Makes the dropdown searchable
                                            className="w-full" // Ensures the Select component takes up full width
                                        /> */}

                                        <input
                                            type="text"
                                            id="searchMember"
                                            value={searchTerm} // Show selected value
                                            options={memberlist}
                                            onChange={handleMemberSelectChange}
                                            placeholder="Type to search members"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        />



                                        {ispersonModalOpen && (
                                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '490px', overflowY: 'auto' }}>
                                                    <div className="flex justify-end">
                                                        <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                                    </div>


                                                    <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse', marginTop: '-10px' }}>
                                                        <thead sx={{ backgroundColor: '#14a3c7' }}>
                                                            <tr>
                                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>First Name</th>
                                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Last Name</th>
                                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Phone Number</th>
                                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Email</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {memberlist.map((member) => (
                                                                <tr
                                                                    key={member.id}
                                                                    onClick={() => handleRowClick(member)}
                                                                    className="cursor-pointer hover:bg-gray-200"
                                                                    style={{ borderBottom: '1px solid #ddd' }}
                                                                >
                                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastname}</td>
                                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                    </div>

                                    <div className="overflow-hidden border border-gray-300 rounded">
                                        <table className="min-w-full border-collapse text-sm">
                                            <thead>
                                                <tr>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">
                                                        <span style={{ fontWeight: 'bolder' }}>Select
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAllChangeFamily}
                                                                checked={selectAllChecked}
                                                                style={{ marginLeft: '-55px' }}
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="border px-2 py-1 bg-gray-200 text-xs">Family Member</th>
                                                </tr>
                                            </thead>
                                        </table>

                                        {/* Scrollable table container */}
                                        <div className="overflow-y-auto max-h-48" style={{ height: '300px' }}>
                                            <table className="min-w-full border-collapse text-sm">
                                                <tbody>
                                                    {familyMembers.map(member => (
                                                        <tr key={member.id}>
                                                            <td className="border px-2 py-1 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(event) => handleCheckboxChangeFamily(event, member.id)} // Use `member.id` for the family memberId
                                                                    checked={selectedMemberlist.includes(member.id)} // Check if this member is selected
                                                                    style={{ height: '17px', textAlign: 'left' }}
                                                                />
                                                            </td>
                                                            <td className="border px-2 py-1 text-xs">
                                                                {member.name}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isModalOpenCreateHead && (



                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                                    <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center' }}>CREATE ACCOUNT HEAD </h6>
                                    <div className="w-full mb-4 flex">

                                    </div>

                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesDescription">Account Head</label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={head}
                                                onChange={(e) => setAccountHead(e.target.value)}
                                                type="text"
                                                placeholder="Enter Account Head"
                                            />
                                        </div>
                                        <div className="w-1/6 mr-2">


                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Currency</label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={currency}
                                                onChange={(e) => setCurrency(e.target.value)}
                                                type="text"
                                                placeholder="Enter Currency"
                                            />
                                        </div>


                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Nature</label>
                                            <Select
                                                options={natureOptions}
                                                value={nature}
                                                onChange={handleChange1}
                                                isSearchable
                                                menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                        minWidth: 0, // allow shrinking
                                                        whiteSpace: "nowrap"
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                        minWidth: "200px",
                                                        whiteSpace: "nowrap",
                                                        overflowX: "auto", // Allows horizontal scrolling if needed
                                                        overflowY: "hidden", // Disables vertical scrolling
                                                        maxHeight: "none"
                                                    }),

                                                }}
                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Parent Group</label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={parent}
                                                //onChange={(e) => setParent(e.target.value)}
                                                type="text"
                                                placeholder="Parent Group"
                                            />
                                        </div>

                                    </div>
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Amt</label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                value={opening}
                                                onChange={(e) => setOpening(e.target.value)}
                                                type="text"
                                                placeholder="Enter Opening"
                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Polarity</label>

                                            <Select
                                                options={optionsp}
                                                value={selectedpolarity} // Important: Bind the value
                                                onChange={handleChange2}
                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Date</label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                value={openingdate}
                                                onChange={(e) => setOpeningDate(e.target.value)}
                                                type="date"
                                                placeholder="Select Date"
                                            />
                                        </div>


                                    </div>




                                    {/* Action Buttons */}
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        <Button onClick={handleFormSubmit1} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                                            Save
                                        </Button>
                                        <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalCloseHead}>
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}



                    </div>

                </form>
            </div >


        </Fragment >
    );
}

export default EventCreate;




